import { RejectedPurchase } from 'apis/merchant-gateway/insights';

export type RejectedPurchaseItem = RejectedPurchase & { id: string; currency: Currency };

export enum RejectedPurchasesTableColumnIDs {
  VENUE = 'VENUE',
  ORDER_TIME = 'ORDER_TIME',
  ORDER_NUMBER = 'ORDER_NUMBER',
  REASON = 'REASON',
  COMMENT = 'COMMENT',
  ORDER_TOTAL = 'ORDER_TOTAL',
}
